module.exports = __webpack_public_path__ + "static/media/thum2.576031d4.jpg";